import { useNavigate } from "react-router-dom";
import { useTaskStore } from "@/store/task";
import { Button } from "@/components/ui/Button";

/**
 * Displays file IDs from GET GetFvTaskAction. Full viewer/download UX can be added later.
 */
export function FvTaskPage() {
  const navigate = useNavigate();
  const fvTaskAction = useTaskStore((s) => s.fvTaskAction);
  const taskItem = useTaskStore((s) => s.taskItem) as { taskID?: number } | undefined;

  const ids = fvTaskAction?.fileIDs?.length ? fvTaskAction.fileIDs : [];

  return (
    <div className="mx-auto max-w-lg py-10">
      <h1 className="mb-3 text-xl font-semibold text-gray-900">Files to review</h1>
      {fvTaskAction?.error ? (
        <p className="text-sm text-red-700">{fvTaskAction.error}</p>
      ) : null}
      {ids.length === 0 ? (
        <p className="text-sm text-gray-600">No files are linked to this task.</p>
      ) : (
        <ul className="mt-4 list-inside list-disc text-sm text-gray-800">
          {ids.map((id) => (
            <li key={id}>File ID: {id}</li>
          ))}
        </ul>
      )}
      {taskItem?.taskID != null ? (
        <p className="mt-4 text-xs text-gray-500">Task ID: {taskItem.taskID}</p>
      ) : null}
      <div className="mt-8">
        <Button type="button" variant="outline" onClick={() => navigate("/")}>
          Back to dashboard
        </Button>
      </div>
    </div>
  );
}
